import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { isObject } from "../../../assets/js/mcn-helpers";
var _perPageOptions = /*#__PURE__*/new WeakMap();
export class Pagination {
  constructor(dataModel, other = {}) {
    _classPrivateFieldInitSpec(this, _perPageOptions, [{
      text: '5',
      value: 5
    }, {
      text: '10',
      value: 10
    }, {
      text: '15',
      value: 15
    }, {
      text: 'pagination.all',
      value: -1
    }]);
    _defineProperty(this, "PaginationCurrentPage", {
      fieldName: 'current_page',
      default: 0,
      content: 0
    });
    _defineProperty(this, "PaginationData", {
      fieldName: 'data',
      model: null,
      default: [],
      content: []
    });
    _defineProperty(this, "PaginationFirstPageUrl", {
      fieldName: 'first_page_url',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationFrom", {
      fieldName: 'from',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationLastPage", {
      fieldName: 'last_page',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationLastPageUrl", {
      fieldName: 'last_page_url',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationLinks", {
      fieldName: 'links',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationNextPageUrl", {
      fieldName: 'next_page_url',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationPath", {
      fieldName: 'path',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationPerPage", {
      fieldName: 'per_page',
      default: null,
      content: null,
      options: []
    });
    _defineProperty(this, "PaginationPreviousPageUrl", {
      fieldName: 'prev_page_url',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationTo", {
      fieldName: 'to',
      default: null,
      content: null
    });
    _defineProperty(this, "PaginationTotal", {
      fieldName: 'total',
      default: 0,
      content: 0
    });
    _defineProperty(this, "loading", {
      content: false
    });
    if (!isObject(other)) other = {};
    let {
      perPage = null,
      perPageOptions = null
    } = other;
    this.PaginationPerPage.options = Array.isArray(perPageOptions) ? perPageOptions : _classPrivateFieldGet(_perPageOptions, this);
    this.PaginationPerPage.content = this.PaginationPerPage.default = perPage !== null && perPage !== void 0 ? perPage : this.PaginationPerPage.options[0].value;
    this.PaginationData.model = dataModel;
  }
  resetPage() {
    this.PaginationCurrentPage.content = 0;
  }
  resetPagination() {
    Object.keys(this).forEach(key => {
      var _this$key$default;
      if (!this[key].fieldName) return;
      this[key].content = (_this$key$default = this[key].default) !== null && _this$key$default !== void 0 ? _this$key$default : null;
    });
    return this;
  }
  startLoading() {
    this.loading.content = true;
    return this;
  }
  isLoading() {
    return this.loading.content;
  }
  endLoading() {
    this.loading.content = false;
    return this;
  }
  getItemsPerPage() {
    var _this$PaginationPerPa;
    return (_this$PaginationPerPa = this.PaginationPerPage) === null || _this$PaginationPerPa === void 0 ? void 0 : _this$PaginationPerPa.content;
  }
  getSelectedItemsPerPage() {
    let itemsPerPage = this.getItemsPerPage();
    if (this.PaginationPerPage.options.map(o => o.value).includes(itemsPerPage)) return itemsPerPage;
    return -1;
  }
  currentPage() {
    var _this$PaginationCurre, _this$PaginationCurre2;
    return this.totalPages() >= ((_this$PaginationCurre = this.PaginationCurrentPage) === null || _this$PaginationCurre === void 0 ? void 0 : _this$PaginationCurre.content) ? (_this$PaginationCurre2 = this.PaginationCurrentPage) === null || _this$PaginationCurre2 === void 0 ? void 0 : _this$PaginationCurre2.content : 1;
  }
  totalPages() {
    return this.getItemsPerPage() > 0 && this.getTotalItems() > 0 ? Math.ceil(this.getTotalItems() / this.getItemsPerPage()) : 1;
  }
  setCurrentPage(currentPage) {
    return this.PaginationCurrentPage.content = currentPage;
  }
  lastPage() {
    var _this$PaginationLastP, _this$PaginationLastP2;
    return (_this$PaginationLastP = (_this$PaginationLastP2 = this.PaginationLastPage) === null || _this$PaginationLastP2 === void 0 ? void 0 : _this$PaginationLastP2.content) !== null && _this$PaginationLastP !== void 0 ? _this$PaginationLastP : 1;
  }
  getTotalItems() {
    var _this$PaginationTotal, _this$PaginationTotal2;
    return (_this$PaginationTotal = (_this$PaginationTotal2 = this.PaginationTotal) === null || _this$PaginationTotal2 === void 0 ? void 0 : _this$PaginationTotal2.content) !== null && _this$PaginationTotal !== void 0 ? _this$PaginationTotal : 0;
  }
  isEmpty() {
    return this.getTotalItems() < 1;
  }
  setTotalItems(totalItems) {
    return this.PaginationTotal.content = totalItems;
  }
  getQuery(page = null, perPage = null, withInterrogationMark = true) {
    var _page;
    page = (_page = page) !== null && _page !== void 0 ? _page : this.currentPage();
    page = !page ? 1 : page;
    return `${withInterrogationMark ? '?' : ''}show=${perPage !== null && perPage !== void 0 ? perPage : this.getItemsPerPage()}&page=${page}`;
  }
  getQueryObject(args) {
    var _page2;
    let {
      perPage = null,
      page = null
    } = args !== null && args !== void 0 ? args : {};
    page = (_page2 = page) !== null && _page2 !== void 0 ? _page2 : this.currentPage();
    page = page ? page : 1;
    return {
      show: perPage !== null && perPage !== void 0 ? perPage : this.getItemsPerPage(),
      page
    };
  }
  static constructQuery(page = 1, perPage = 10) {
    return `?show=${perPage !== null && perPage !== void 0 ? perPage : 10}&page=${page !== null && page !== void 0 ? page : 1}`;
  }
  getPaginatedData() {
    var _this$PaginationData$, _this$PaginationData;
    return (_this$PaginationData$ = (_this$PaginationData = this.PaginationData) === null || _this$PaginationData === void 0 ? void 0 : _this$PaginationData.content) !== null && _this$PaginationData$ !== void 0 ? _this$PaginationData$ : [];
  }
  pageHasItems() {
    return this.getPaginatedData().length > 0;
  }
  hasItems() {
    return this.getTotalItems() > 0;
  }
  setPaginatedData(data) {
    this.PaginationData.content = data;
    return this;
  }
  setPerPageItems(n) {
    this.PaginationPerPage.content = n;
    return this;
  }
  setItemsPerPage(n) {
    this.PaginationPerPage.content = n;
    return this;
  }
  hasItemsThenItemsPerPage() {
    return this.getTotalItems() > this.getItemsPerPage();
  }
}
_defineProperty(Pagination, "BY_TWELVE_PAGINATION_LIST", [{
  text: '12',
  value: 12
}, {
  text: '24',
  value: 24
}, {
  text: '36',
  value: 36
}, {
  text: 'pagination.all',
  value: -1
}]);
_defineProperty(Pagination, "BY_TEN_PAGINATION_LIST", [{
  text: '5',
  value: 5
}, {
  text: '10',
  value: 10
}, {
  text: '15',
  value: 15
}, {
  text: 'pagination.all',
  value: -1
}]);
export default Pagination;